import { render, staticRenderFns } from "./NewDashBoard.vue?vue&type=template&id=ddb05010&scoped=true"
import script from "./NewDashBoard.vue?vue&type=script&lang=js"
export * from "./NewDashBoard.vue?vue&type=script&lang=js"
import style0 from "./NewDashBoard.vue?vue&type=style&index=0&id=ddb05010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb05010",
  null
  
)

export default component.exports